import { showLoading, hideLoading } from 'react-redux-loading';
import { AUTH_USER, AUTH_ERROR } from './types';
import { login } from '../services/authService';
import { setTokenHeader } from '../services/apiService';
// import setSentryUser from './setSentryUser';
import * as storage from '../storage';


export const signin = (formProps, cb) => async (dispatch) => {
  dispatch(showLoading());
  try {
    const { email, password } = formProps;
    // setSentryUser(email);
    const response = await login(email, password);
    const { token } = response.data;
    dispatch({ type: AUTH_USER, payload: token });
    storage.local.setItem('token', token);
    setTokenHeader(token);
    dispatch(hideLoading());
    cb();
  } catch (e) {
    dispatch({ type: AUTH_ERROR, payload: 'Invalid login credentials' });
    dispatch(hideLoading());
  }
};

export const signout = cb => (dispatch) => {
  storage.local.removeItem('token');
  setTokenHeader(false);
  dispatch({ type: AUTH_USER, payload: '' });
  cb();
};
